exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".state{white-space:nowrap}.table-new,.table-new>td,.table-new>th{font-weight:600}.toolbar{padding:0 0 30px;display:flex;justify-content:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3edb762e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Mail.vue
// module id = 647
// module chunks = 0